module.exports = {
      id: "zhihu_logo-usage",
      viewBox: "0 0 69 32",
      url: __webpack_public_path__ + "images/js_src_vue/page_listary_landing/sprite.d9b7df9a.svg#zhihu_logo-usage",
      toString: function () {
        return this.url;
      }
    }